import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup } from 'react-bootstrap';
import EditableRichText from '../../../../../../src/web/containers/EditableRichText';
import styles from '../PopupFields/styles.scss';

const propTypes = {
  onControlChange: PropTypes.func.isRequired,
  onTextEditorFinish: PropTypes.func.isRequired,
  thankYouHeaderText: PropTypes.string.isRequired,
  thankYouBodyContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  thankYouButtonText: PropTypes.string.isRequired,
};

const defaultProps = {};

const attrs = [
  'onControlChange',
  'onTextEditorFinish',
  'thankYouHeaderText',
  'thankYouBodyContent',
  'thankYouButtonText',
];

const ThankYouFields = ({
  onControlChange,
  onTextEditorFinish,
  thankYouHeaderText,
  thankYouBodyContent,
  thankYouButtonText,
}) => (
  <Row>
    <Col xs={12}>
      <FormGroup className={styles.FormGroup}>
        <label htmlFor="thankYouHeaderText" className="pb-1">Header Text</label>
        <Form.Control name="thankYouHeaderText" onChange={onControlChange} value={thankYouHeaderText} />
      </FormGroup>
      <FormGroup className={styles.FormGroup}>
        <label htmlFor="thankYouBodyContent" className="pb-1">Body Text</label>
        <EditableRichText
          editing
          editorKey="popup-builder-thanks"
          rawContentState={thankYouBodyContent}
          onChange={rawContentState => onTextEditorFinish({ name: 'thankYouBodyContent', rawContentState })}
        />
      </FormGroup>
      <FormGroup className={styles.FormGroup}>
        <label htmlFor="thankYouButtonText" className="pb-1">Button Text</label>
        <Form.Control name="thankYouButtonText" onChange={onControlChange} value={thankYouButtonText} />
      </FormGroup>
    </Col>
  </Row>
);

ThankYouFields.propTypes = propTypes;
ThankYouFields.defaultProps = defaultProps;
ThankYouFields.attrs = attrs;

export default ThankYouFields;
